import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';

const SEARCH_UTM_URI: string = environment.API_URL + '/utm/search';
const CREATE_UTM_URI: string = environment.API_URL + '/utm/create';

export interface UtmData {
  id: number;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
  ipAddress: string;
  userAgent: string;
  trackedAt: string;
}

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number; // current page number (0-based)
}

@Injectable({
  providedIn: 'root',
})
export class UtmDataService {
  constructor(private http: HttpClient) {}

  /**
   * Sends UTM data + metadata to backend
   */
  sendUtmToBackend(utmData: any): void {
    console.log('payload Sent to backend', utmData);
    this.http.post(CREATE_UTM_URI, utmData).subscribe({
      next: () => console.log('[UTM] Sent to backend'),
      error: (err) => console.error('[UTM] Error sending to backend', err),
    });
  }
  getUtmData(
    search: string = '',
    page: number = 0,
    size: number = 10,
    sortBy: string = 'trackedAt',
    sortDir: string = 'desc',
  ): Observable<PaginatedResponse<UtmData>> {
    let params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortDir', sortDir);

    return this.http.get<PaginatedResponse<UtmData>>(SEARCH_UTM_URI, { params });
  }
}
